"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useShoppingStockOrderingGroup;

var _react = require("react");

var _invariant = _interopRequireDefault(require("invariant"));

var _ShoppingContext = _interopRequireDefault(require("../ShoppingProvider/ShoppingContext"));

function useShoppingStockOrderingGroup() {
  var ctx = (0, _react.useContext)(_ShoppingContext.default);
  (0, _invariant.default)(ctx, "Don't use 'useShoppingStockOrderingGroup' outside of <ShoppingProvider>");
  return ctx.stockOrderingGroup;
}